import { render, staticRenderFns } from "./ArrowLink.vue?vue&type=template&id=020591c9"
import script from "./ArrowLink.vue?vue&type=script&lang=js"
export * from "./ArrowLink.vue?vue&type=script&lang=js"
import style0 from "./ArrowLink.vue?vue&type=style&index=0&id=020591c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports